import api from "../../api";
import to from "await-to-js";
import qs from 'qs'

const artistsSearchRequests = {
    searchArtists: async (queryData, searchCase) => {
        let query = null

        if (searchCase === 'keyword') {
            query = qs.stringify({
                _start: queryData.start,
                _limit: queryData.limit,
                _sort: `dateStart:${queryData.sortType}`,
                _where: {
                    'isArtistInResidency': true,
                    'name_contains': queryData.string
                },
            });
        }
        if (searchCase === 'tag') {
            query = qs.stringify({
                _start: queryData.start,
                _limit: queryData.limit,
                _sort: `dateStart:${queryData.sortType}`,
                _where: {
                    'isArtistInResidency': true,
                    'tags.tagName_contains': queryData.param
                },
            })
        }
        if (searchCase === 'year') {
            query = qs.stringify({
                _start: queryData.start,
                _limit: queryData.limit,
                _sort: `dateStart:${queryData.sortType}`,
                _where: {
                    'isArtistInResidency': true,
                    'name_contains': queryData.string,
                    'year.year_contains': queryData.param
                },
            });
        }
        if (searchCase === 'keywordTag') {
            query = qs.stringify({
                _start: queryData.start,
                _limit: queryData.limit,
                _sort: `dateStart:${queryData.sortType}`,
                _where: {
                    'isArtistInResidency': true,
                    'tags.tagName_eq': queryData.param,
                    'name_contains': queryData.string
                },
            });
        }
        if (searchCase === 'keywordYear') {
            query = qs.stringify({
                _start: queryData.start,
                _limit: queryData.limit,
                _sort: `dateStart:${queryData.sortType}`,
                _where: {
                    'isArtistInResidency': true,
                    'year.year_eq': queryData.param,
                    'name_contains': queryData.string
                },
            });
        }
        if (searchCase === 'keywordTagYear') {
            query = qs.stringify({
                _start: queryData.start,
                _limit: queryData.limit,
                _sort: `dateStart:${queryData.sortType}`,
                _where: {
                    'isArtistInResidency': true,
                    'tags.tagName_eq': queryData.param,
                    'year.year_eq': queryData.secondParam,
                    'name_contains': queryData.string
                },
            });
        }
        if (searchCase === 'tagYear') {
            query = qs.stringify({
                _start: queryData.start,
                _limit: queryData.limit,
                _sort: `dateStart:${queryData.sortType}`,
                _where: {
                    'isArtistInResidency': true,
                    'tags.tagName_eq': queryData.param,
                    'year.year_eq': queryData.secondParam,
                },
            });
        }

        let resourceString = `artists?${query}`
        let [error, response] = await to(api.GETPUBLIC_QUERY(resourceString));
        if (error) {
            throw error
        }
        if (response.status === "fail") {
            throw { ...response };
        } else {
            return response;
        }
    },

};

export default artistsSearchRequests;
